import React from "react";
import { FaHtml5, FaCss3, FaJs, FaReact, FaNode, FaGithub, FaGit, FaDocker, FaNpm, FaSass, FaPhp, FaLaravel } from "react-icons/fa";
import { DiMongodb, DiPostgresql, DiMysql } from "react-icons/di"
import { SiTypescript, SiNextdotjs, SiTailwindcss, SiCsharp} from "react-icons/si"

const Skills = () => {
    const skills = [
        {
            icon: <FaHtml5 size={"40px"}/>,
            name: "HTML5"
        },
        {
            icon: <FaCss3 size={"40px"}/>,
            name: "CSS3"
        },
        {
            icon: <FaSass size={"40px"}/>,
            name: "Sass"
        },
        {
            icon: <FaJs size={"40px"}/>,
            name: "javascript"
        },
        {
            icon: <FaReact size={"40px"}/>,
            name: "React"
        },
        {
            icon: <SiNextdotjs size={"40px"}/>,
            name: "NodeJs"
        },
        {
            icon: <SiTypescript size={"40px"}/>,
            name: "Typescript"
        },
        {
            icon: <FaNode size={"40px"}/>,
            name: "NextJs"
        },
        {
            icon: <FaPhp size={"40px"}/>,
            name: "PHP"
        },
        {
            icon: <FaLaravel size={"40px"}/>,
            name: "laravel"
        },
        {
            icon: <SiCsharp size={"40px"}/>,
            name: "Csharp"
        },
        {
            icon: <SiTailwindcss size={"40px"}/>,
            name: "Tailwindcss"
        },
        {
            icon: <FaGithub size={"40px"}/>,
            name: "Github"
        },
        {
            icon: <FaGit size={"40px"}/>,
            name: "Git"
        },
        {
            icon: <DiMongodb size={"40px"}/>,
            name: "Mongodb"
        },
        {
            icon: <DiPostgresql size={"40px"}/>,
            name: "Postgresql"
        },
        {
            icon: <DiMysql size={"40px"}/>,
            name: "Mysql"
        },
        {
            icon: <FaDocker size={"40px"}/>,
            name: "Docker"
        },
        {
            icon: <FaNpm size={"40px"}/>,
            name: "Npm"
        },
        
    ]
    return (
      <div
        className="py-[64px] bg-black bg-gradient-to-b from-zinc-900 via-zinc-400/10 to-zinc-900"
        id="skills"
      >
        <div className="flex flex-col p-6 justify-center items-center space-y-2">
          <h3 className="text-zinc-100 text-bold text-2xl font-bold uppercase">
            Skills
          </h3>
          <p className="text-italics text-center">
            Programming Languages, Libraries and Frameworks
          </p>
          <br/>
          <div className="w-full inline-flex space-x-4 flex-nowrap overflow-hidden group [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]">
            {skills &&
              skills.map((skill) => (
                <div
                  key={skill.name}
                  className="flex flex-col items-center space-y-2 animate-infinite-scroll group-hover:paused"
                >
                  {skill.icon}
                  <span className="text-xs">{skill.name}</span>
                </div>
              ))}
            {skills &&
              skills.map((skill) => (
                <div
                  key={skill.name}
                  className="flex flex-col items-center space-y-2 animate-infinite-scroll group-hover:paused"
                  aria-hidden="true"
                >
                  {skill.icon}
                  <span className="text-xs">{skill.name}</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
}
 
export default Skills;